(function () {
    'use strict';
    Component_IntakeFieldController.$inject = ['$scope', '$attrs', '$element', 'FileUtil', 'SelectorDataQuery'];

    function Component_IntakeFieldController($scope, $attrs, $element, FileUtil, SelectorDataQuery) {
//
        var $ctrl = this;
        $ctrl.selectableItems = [];
        $ctrl.selectableItemsFilled = false;
        $ctrl.checkChange = checkChange;

        $scope.$watch('$ctrl.field', function (field) {
            if (field) {
                fillSelectableItems();

            }


        });
        $scope.$watch('$ctrl.isEditMode', function (field) {
            if (field) {
                fillSelectableItems();

            }


        });

        function fillSelectableItems() {
            if ($ctrl.isEditMode && !$ctrl.selectableItemsFilled && $ctrl.field.field && $ctrl.field.field.selectorDataTypeId) {
                SelectorDataQuery.findByTypeId($ctrl.field.field.selectorDataTypeId).query(function (data) {

                    if (data) {
                        $ctrl.selectableItems = [];
                        angular.forEach(data, function (item) {
                            $ctrl.selectableItems.push(item.text);
                        })
                        $ctrl.selectableItemsFilled = true;
                    }

                })
            }
        }

        function checkChange() {
            $ctrl.field.value = $ctrl.field.checkValue;
        }

    }


    var Component_IntakeFieldViewer = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/intake-data-component/component-intake-field.template.html',
        controller: Component_IntakeFieldController,
        bindings: {
            field: '=',
            isEditMode: '<'
        }

    };

    angular
        .module('tikonApp')
        .component('componentIntakeField', Component_IntakeFieldViewer)

})();
